
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/pms/[pid]",
      function () {
        return require("private-next-pages/download/pms/[pid].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/download/pms/[pid]"])
      });
    }
  